// طبقة عملات CP الذهبية المتحركة (خلف المحتوى بالكامل).
// pointer-events:none · تحترم prefers-reduced-motion · تقلل عدد العملات على الجوال.
import React, { useEffect, useMemo, useRef } from "react";
import "./CPCoinsLayer.css";

const isReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const useCoinCount = () => {
  const w = typeof window !== "undefined" ? window.innerWidth : 1200;
  if (isReducedMotion()) return 0;
  if (w < 480) return 3;   // mobile
  if (w < 900) return 4;   // tablet
  return 5;                // desktop
};

const rand = (min, max) => Math.random() * (max - min) + min;

const CPCoinsLayer = () => {
  const containerRef = useRef(null);
  const count = useCoinCount();

  const coins = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const size = rand(12, 32);
      const isDeep = size < 20; // العملات الصغيرة أبعد ومعتّمة أكثر
      return {
        id: i,
        size: Math.round(size),
        left: rand(0, 100), // %
        duration: rand(18, 30), // s (أهدأ)
        delay: rand(-20, 0.5), // s
        drift: rand(-30, 30), // px
        spinDur: rand(5, 10), // s
        opacity: isDeep ? rand(0.15, 0.3) : rand(0.3, 0.5),
      };
    });
  }, [count]);

  if (count === 0) return null;

  return (
    <div className="cp-coins-layer" ref={containerRef} aria-hidden="true">
      {coins.map((c) => (
        <span
          key={c.id}
          className="cp-coin"
          style={{
            left: `${c.left}%`,
            width: `${c.size}px`,
            height: `${c.size}px`,
            opacity: c.opacity,
            animationDuration: `${c.duration}s`,
            animationDelay: `${c.delay}s`,
            "--drift": `${c.drift}px`,
          }}
        >
          <span
            className="cp-coin-spin"
            style={{ animationDuration: `${c.spinDur}s` }}
          >
            <svg viewBox="0 0 64 64" width="100%" height="100%">
              <defs>
                <linearGradient id={`g${c.id}`} x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#F6DFA7" />
                  <stop offset="45%" stopColor="#D4B278" />
                  <stop offset="100%" stopColor="#8C6A34" />
                </linearGradient>
              </defs>
              <circle cx="32" cy="32" r="30" fill={`url(#g${c.id})`} stroke="#5B4319" strokeWidth="2" />
              <circle cx="32" cy="32" r="22" fill="none" stroke="#5B4319" strokeWidth="1.5" opacity="0.5" />
              <text
                x="32"
                y="41"
                textAnchor="middle"
                fontFamily="ui-sans-serif, system-ui"
                fontWeight="900"
                fontSize="22"
                fill="#3B2A0F"
              >
                CP
              </text>
            </svg>
          </span>
        </span>
      ))}
    </div>
  );
};

export default CPCoinsLayer;
